var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#070000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6763 5.6875H20.1573L14.737 11.8825L21.1135 20.3125H16.1208L12.2103 15.1998L7.73579 20.3125H5.25331L11.0508 13.6863L4.93381 5.6875H10.0533L13.588 10.3608L17.6763 5.6875ZM16.8055 18.8275H18.1803L9.30629 7.0945H7.83104L16.8055 18.8275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.1bcee47e13bb277610b9dd14d5f64563.svg";
export { ForwardRef as ReactComponent };